import React from 'react';
import { BaseStatusIndicatorProps } from '.';
import Indicator, { IndicatorColor } from '@/components/Indicator';
import { ExternalAgreementStatus } from '@/types';
import { useLingui } from '@lingui/react';

interface StatusIndicatorProps extends BaseStatusIndicatorProps {
    value: ExternalAgreementStatus;
}

const colorMap: { [key in ExternalAgreementStatus]: IndicatorColor } = {
    Pending: 'warning',
    Rejected: 'danger',
    Approved: 'success',
    Canceled: 'danger',
};

const ExternalAgreementStatusIndicator: React.FC<StatusIndicatorProps> = ({ value, children, ...rest }) => {
    const { _ } = useLingui();

    return (
        <Indicator color={colorMap[value]} {...rest}>
            {children || _({ id: `ExternalAgreementStatus.${value}` })}
        </Indicator>
    );
};

export default ExternalAgreementStatusIndicator;
